<template>
  <div class="flex flex-col">
    <!--
      Design by new sketch.
      <div class="flex justify-between items-center border-b pl-8 pr-4 py-4">
      <div class="flex items-center space-x-4">
        <div class="w-10 h-10 rounded-full bg-custom-orange-100 flex items-center justify-center  ">
          <Icon
            :name="icon"
            class="text-2xl text-custom-orange-400"
          />
        </div>
        <div>
          <div class=" font-medium text-base">
            Henrik Wridl
          </div>
          <div class=" font-medium text-custom-gray-400 text-sm">
            Board member
          </div>
        </div>
      </div>
      <div class="flex items-center space-x-8">
        <div>
          <div class=" font-medium text-custom-gray-400 text-xs text-right">
            Type
          </div>
          <div class=" font-medium text-sm ">
            Acquisitions
          </div>
        </div> 
        <div>
          <div class=" font-medium text-custom-gray-400 text-xs text-right">
            Share amount
          </div>
          <div class=" font-medium text-sm ">
            362 388
          </div>
        </div>  
        <div>
          <div class=" font-medium text-custom-gray-400 text-xs text-right">
            Share price
          </div>
          <div class=" font-medium text-sm ">
            1.23 EUR
          </div>
        </div>  
        <div>
          <div class=" font-medium text-custom-gray-400 text-xs text-right">
            Date
          </div>
          <div class=" font-medium text-sm ">
            02/10/2023
          </div>
        </div>   
      </div>
    </div>
    <div class="flex justify-between items-center border-b pl-8 pr-4 py-4">
      <div class="flex items-center space-x-4">
        <div class="w-10 h-10 rounded-full bg-custom-orange-100 flex items-center justify-center  ">
          <Icon
            :name="icon"
            class="text-2xl text-custom-orange-400"
          />
        </div>
        <div>
          <div class=" font-medium text-base">
            Ollie Goodman
          </div>
          <div class=" font-medium text-custom-gray-400 text-sm">
            CEO
          </div>
        </div>
      </div>
      <div class="flex items-center space-x-8">
        <div>
          <div class=" font-medium text-custom-gray-400 text-xs text-right ">
            Type
          </div>
          <div class=" font-medium text-sm ">
            Subscribe for shares
          </div>
        </div> 
        <div>
          <div class=" font-medium text-custom-gray-400 text-xs text-right">
            Share amount
          </div>
          <div class=" font-medium text-sm ">
            916 388
          </div>
        </div>  
        <div>
          <div class=" font-medium text-custom-gray-400 text-xs text-right">
            Share price
          </div>
          <div class=" font-medium text-sm ">
            1.23 EUR
          </div>
        </div>  
        <div>
          <div class=" font-medium text-custom-gray-400 text-xs text-right">
            Date
          </div>
          <div class=" font-medium text-sm ">
            02/10/2023
          </div>
        </div>   
      </div>
    </div> -->
    <div
      class="flex justify-between items-center p-4 border-b dark:border-custom-purple-600"
      :class="insider.status === 'Reviderad' ? 'text-gray-400 dark:text-custom-purple-100' : ''"
    >
      <div class="flex items-center">
        <div class="flex w-12 h-8 flex-shrink-0 items-center">
          <Icon
            :name="icon"
            class="text-2xl ml-1"
            :class="iconTypeClass"
          />
        </div>
        <div class="flex flex-col">
          <RouterLink
            v-if="companyId"
            :to="{name: 'companyOverview', params: {id: companyShortName}}"
            class="text-xs"
            :class="insider.status === 'Reviderad' ? 'text-gray-400 dark:text-custom-purple-100' : 'text-custom-purple-500 dark:text-custom-dark-header'"
          >
            {{ companyName }}
          </RouterLink>
          <p
            v-else
            class="text-xs dark:text-custom-purple-100"
          >
            {{ companyName }}
          </p>
          <p class="text-sm font-semibold dark:text-custom-purple-100">
            {{ insider.person }} <template v-if="insider.status === 'Reviderad'">
              (Reviderad)
            </template>
          </p>
          <p
            class="text-3xs font-semibold dark:text-custom-purple-100"
          >
            ({{ insider.occupation.indexOf('Annan') > -1 ? 'Annan' : insider.occupation }})
          </p>
          <p class="text-xs dark:text-custom-purple-100">
            {{ insider.type }}
          </p>
        </div>
      </div>
      <div class="text-xs text-right flex flex-col justify-center flex-shrink-0 pl-2">
        <p
          class="font-medium"
          :class="[typeClass, positive ? 'dark:text-custom-green-500' : '']"
        >
          {{ insider.price }} {{ insider.currency }}
        </p>
        <p class="font-medium dark:text-custom-purple-100">
          {{ parseFloat(insider.volume).toLocaleString('en-US', {maximumFractionDigits: 2}).replace(/,/g, ' ') }} {{ insider.volume_unit }}
        </p>
        <p class="text-xs dark:text-custom-purple-100">
          {{ publishDate }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'InsiderTrade',
  props: {
    insider: {
      type: Object,
      default: () => {}
    },
    icon: {
      type: String,
      default: 'coin-stack'
    },
    typeClass: {
      type: String,
      default: 'text-gray-500'
    },
    iconTypeClass: {
      type: String,
      default: 'text-gray-500'
    },
    positive: {
      type: Boolean,
      default: false
    },
    companyName: {
      type: String,
      default: ''
    },
    companyId: {
      type: Number,
      default: 0
    },
    companyShortName: {
      type: String,
      default: ''
    },
    publishDate: {
      type: String,
      default: ''
    }
  }
}
</script>
